<template>
    <div>
        <b-row>
            <b-col v-if="!orgRoleIsPermitted(OrgRoles.CUSTOMER_FL44)">
                <h3 class="grey-color main_text font-weight-bold">История рейтинга поставщика</h3>
            </b-col>
            <b-col v-else>
                <h3 class="grey-color main_text font-weight-bold">История рейтинга организации</h3>
            </b-col>
            <b-col md="auto">
                <b-badge v-if="isCustomerRating" class="mt-1 fs-18" variant="custom-green">
                    <b-icon-star-fill />
                    <span class="ml-2">{{ $store.state.organization.customer_rating }}</span>
                </b-badge>
                <b-badge v-else class="mt-1 fs-18" variant="custom-green">
                    <b-icon-star-fill />
                    <span class="ml-2">{{ $store.state.organization.rating }}</span>
                </b-badge>
            </b-col>
        </b-row>
        <b-row v-if="orgRoleIsPermitted(OrgRoles.CUSTOMER_FL44)">
            <b-col>
                <b-form-radio-group v-model="isCustomerRating" :options="isCustomerRatingValues" class="mb-2" @input="getRatings" />
            </b-col>
        </b-row>

        <b-table v-if="isCustomerRating" :busy="isLoading" :fields="customerFields" :items="ratings" class="table-atmo" empty-text="Нет данных" show-empty>
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
            <template #cell(rate_date)="row">
                {{ $formatDate(row.item.rate_date) }}
            </template>
            <template #cell(purchasable_id)="row">
                <router-link v-if="row.item.purchasable_type === 'purchase'" class="atmo-button-link fw-400" :to="{ name: 'purchases.grouped.item.view', params: { group: 'fl44', id: row.item.purchasable_id } }" target="_blank">
                    {{ row.item.purchase_reg_number }}
                </router-link>
                <router-link v-else class="atmo-button-link fw-400" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: row.item.purchasable_id } }" target="_blank">
                    {{ row.item.purchase_reg_number }}
                </router-link>
            </template>
            <template #cell(provider_id)="row">
                <router-link  v-if="row.item.provider_id" class="atmo-button-link" :to="{ name: 'OrganizationShow', params: { id: row.item.provider_id } }" target="_blank">
                    {{ row.item.provider_name }}
                </router-link>
                <span v-else> Запись о рейтинге создана автоматически при заключении контракта </span>
            </template>
            <template #cell(actions)="data">
                <action-button-small v-if="data.item.provider_id || data.item.comment" v-b-popover.hover.top="(data.detailsShowing ? 'Скрыть' : 'Показать') + ' подробности'" :icon="data.detailsShowing ? 'eye-slash' : 'eye'" @click="data.toggleDetails" />
            </template>
            <template #row-details="data">
                <p v-if="data.item.user_name" class="mb-1"><b>Пользователь поставщика:</b> {{ data.item.user_name }}</p>
                <p v-if="data.item.comment" class="mb-1"><b>Комментарий:</b> {{ data.item.comment }}</p>
            </template>
        </b-table>
        <b-table v-else :busy="isLoading" :fields="supplierFields" :items="ratings" class="table-atmo" empty-text="Нет данных" show-empty>
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
            <template #cell(rate_date)="row">
                {{ $formatDate(row.item.rate_date) }}
            </template>
            <template #cell(purchasable_id)="row">
                <router-link v-if="row.item.purchasable_type === 'purchase'" class="atmo-button-link fw-400" :to="{ name: 'purchases.grouped.item.view', params: { group: 'fl44', id: row.item.purchasable_id } }" target="_blank">
                    {{ row.item.purchase_reg_number }}
                </router-link>
                <router-link v-else class="atmo-button-link fw-400" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: row.item.purchasable_id } }" target="_blank">
                    {{ row.item.purchase_reg_number }}
                </router-link>
            </template>
            <template #cell(customer_id)="row">
                <router-link v-if="row.item.customer_id" class="atmo-button-link" :to="{ name: 'OrganizationShow', params: { id: row.item.customer_id } }" target="_blank">
                    {{ row.item.customer_name }}
                </router-link>
                <span v-else> Запись о рейтинге создана автоматически при заключении контракта </span>
            </template>
            <template #cell(actions)="data">
                <action-button-small v-if="data.item.customer_id || data.item.comment" v-b-popover.hover.top="(data.detailsShowing ? 'Скрыть' : 'Показать') + ' подробности'" :icon="data.detailsShowing ? 'eye-slash' : 'eye'" @click="data.toggleDetails" />
            </template>
            <template #row-details="data">
                <p v-if="data.item.user_name" class="mb-1"><b>Пользователь заказчика:</b> {{ data.item.user_name }}</p>
                <p v-if="data.item.comment" class="mb-1"><b>Комментарий:</b> {{ data.item.comment }}</p>
            </template>
        </b-table>
    </div>
</template>

<script>
import { OrgRoles } from '@/const';

export default {
    name: 'cabinet-fl44-rating-history',
    computed: {
        OrgRoles() {
            return OrgRoles
        }
    },
    metaInfo: {
        title: 'История рейтинга'
    },
    data() {
        return {
            isLoading: true,
            ratings: [],
            isCustomerRatingValues: [
                { value: false, text: 'Рейтинг поставщика' },
                { value: true, text: 'Рейтинг заказчика' },
            ],
            isCustomerRating: false,
            supplierFields: [
                { key: 'rate_date', label: 'Дата выставления оценки', thStyle: { width: '100px' }, tdClass: 'align-text-top py-1' },
                { key: 'rating', label: 'Оценка', thStyle: { width: '80px' }, tdClass: 'align-text-top py-1' },
                { key: 'purchasable_id', label: 'Рег.номер закупки', thStyle: { width: '150px' }, tdClass: 'align-text-top py-1' },
                { key: 'customer_id', label: 'Заказчик', tdClass: 'align-text-top py-1' },
                { key: 'actions', label: '', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap', thStyle: { width: '1px' } }
            ],
            customerFields: [
                { key: 'rate_date', label: 'Дата выставления оценки', thStyle: { width: '100px' }, tdClass: 'align-text-top py-1' },
                { key: 'rating', label: 'Оценка', thStyle: { width: '80px' }, tdClass: 'align-text-top py-1' },
                { key: 'purchasable_id', label: 'Рег.номер закупки', thStyle: { width: '150px' }, tdClass: 'align-text-top py-1' },
                { key: 'provider_id', label: 'Поставщик', tdClass: 'align-text-top py-1' },
                { key: 'actions', label: '', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap', thStyle: { width: '1px' } }
            ],
        };
    },
    async mounted() {
        await this.getRatings();
        this.$scrollToTop();
    },
    methods: {
        async getRatings() {
            this.isLoading = true;
            const response = await this.$api.personal.ratingHistory.getList(this.isCustomerRating);
            this.ratings = response.data;
            this.isLoading = false;
        }
    }
};
</script>
